import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Checkout } from '@pdqdev/pdq-shared/dist/interfaces';
import { CheckoutApiService } from './api/checkout.api.service';

export interface ItemFeeSetup {
  id: number;
  name: string;
  rules: Checkout.FeePerItemGroupRule[];
  overlapMode?: Checkout.RuleOverlapMode;
  unmatchedFee?: Checkout.UnmatchedItemFee;
  methodCount: number;
}

export interface SaveItemFeeSetupPayload {
  name?: string;
  rules?: Checkout.FeePerItemGroupRule[];
  overlapMode?: Checkout.RuleOverlapMode;
  unmatchedFee?: Checkout.UnmatchedItemFee | null;
  linkToShippingId?: number;
}

const BASE_PATH = 'admin/v1/item-fee-setups';

@Injectable({ providedIn: 'root' })
export class ItemFeeSetupsService {
  constructor(private checkoutApi: CheckoutApiService) {}

  list(): Promise<ItemFeeSetup[]> {
    return firstValueFrom(this.checkoutApi.get(BASE_PATH));
  }

  create(payload: SaveItemFeeSetupPayload): Promise<ItemFeeSetup> {
    return firstValueFrom(this.checkoutApi.post(BASE_PATH, payload));
  }

  update(setupId: number, payload: SaveItemFeeSetupPayload): Promise<ItemFeeSetup> {
    return firstValueFrom(this.checkoutApi.patch(`${BASE_PATH}/${setupId}`, payload));
  }

  remove(setupId: number): Promise<{ unlinkedMethods: number }> {
    return firstValueFrom(this.checkoutApi.delete(`${BASE_PATH}/${setupId}`));
  }

  detach(shippingId: number): Promise<{ success: boolean; configurationId: number | null }> {
    return firstValueFrom(this.checkoutApi.post(`${BASE_PATH}/detach/${shippingId}`));
  }
}
